import { render, staticRenderFns } from "./AreaSupportEdit.vue?vue&type=template&id=79eea7ee"
import script from "./AreaSupportEdit.vue?vue&type=script&lang=js"
export * from "./AreaSupportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports